import YFormPostAlbum from './PostAlbum';

export { YFormPostAlbum };
export default YFormPostAlbum;
